module.exports = new __parcel__URL__("b2b-icon-retail.256f34b2.png").toString();